import { DataAccessService } from "../../core/api";

export async function getRules() {
    const client = new DataAccessService({
        baseURL: `/api`
    });

   return await client.get(`/rules`);
}